export default __webpack_public_path__ + "static/media/jumbotron-img.56a07ebc.jpg";